import { Component } from "@angular/core";
import {
  Platform,
  NavParams,
  ViewController,
  ModalController,
} from "ionic-angular";
import { SummaryServiceProvider } from "../../../../providers/wh/summary-service";
import { ChangeUserInfoCpModalComponent } from "../edit-cp-user-info/edit-cp-user-info-modal";
import { AddUserCpModalComponent } from "../add-cp-user-info/add-cp-user-info-modal";

@Component({
  selector: "list-rto-days-modal",
  templateUrl: "list-rto-days-modal.html",
  providers: [SummaryServiceProvider],
})
export class ListRTODaysModalComponent {
  data;
  clientList;
  selectedClient: any;
  returnDays: any;
  selectedRTODays: any;

  constructor(
    public platform: Platform,
    public params: NavParams,
    public summaryService: SummaryServiceProvider,
    public viewCtrl: ViewController
  ) {
    this.data = this.params.get("data");
    this.returnDays = this.data.returnDays;
    console.log(this.data);

    this.clientList = JSON.parse(
      localStorage.getItem("fuFilters")
    ).ecommerceEntity;
  }

  addRTODays() {
    if (this.selectedClient && this.selectedRTODays) {
      let selectedModel = {
        eId: this.selectedClient.id,
        clientName: this.selectedClient.value,
        returnDays: this.selectedRTODays,
      };
      this.returnDays.push(selectedModel);
    } else {
      alert("Please select the client and RTO days");
    }
  }

  removeRTODays(item) {
    var index = this.returnDays.indexOf(item);
    this.returnDays.splice(index, 1);
  }

  saveRTODays(id) {
    let payload = {
      returnDays: JSON.stringify(this.returnDays),
    };
    this.summaryService.patchCPInfo(id, payload).then((res) => {
      this.viewCtrl.dismiss(true);
    });
  }

  dismiss() {
    this.viewCtrl.dismiss(true);
  }
}



// WEBPACK FOOTER //
// ./src/pages/backoffice/collecion-points/list-rto-days-modal/list-rto-days-modal.ts